import {Pipe, PipeTransform} from '@angular/core';
import {MdpDrug} from '../contracts/mdp-drug';

@Pipe({
  name: 'eligiblityCheck'
})

/**
 * UserNamePipe. Gives the Name of the  user logged in and viewing dashboard
 *
 * __Usage :__
 *  ```
 *  <h1>{{ 'userData' | username:'firstName'}}</h1>
 *  userData: user
 *  args='firstName' gives firstName from user Data
 */


export class EligiblityCheck implements PipeTransform {

  transform(availableRx,
    args?: any): any {
    let filteredRx = availableRx;
    const isEligible = args === 'eligible';
    filteredRx = filteredRx.filter(drug => {
      return drug.eligibility === isEligible;
    });
    return filteredRx;
  }
}
